import React from "react";
import PropTypes from "prop-types";
import "./SectionHeading.scss";

export default function SectionHeading({
	children,
	level = "2",
	withUnderline = false
}) {
	const Tag = `h${level}`;

	return (
		<div className="slp-section-heading">
			<Tag className="slp-section-heading__text">{children}</Tag>
			{withUnderline && (
				<div className="slp-section-heading__underline" />
			)}
		</div>
	);
}

SectionHeading.propTypes = {
	children: PropTypes.node.isRequired,
	level: PropTypes.oneOf(["1", "2", "3", "4"]),
	withUnderline: PropTypes.bool
};
